import LanguageSelector from './LanguageSelector';

export { LanguageSelector };